import { render, staticRenderFns } from "./RequiredNutrientSurchargeDiscount.vue?vue&type=template&id=0face833&scoped=true&lang=html&"
import script from "./RequiredNutrientSurchargeDiscount.vue?vue&type=script&lang=js&"
export * from "./RequiredNutrientSurchargeDiscount.vue?vue&type=script&lang=js&"
import style0 from "./RequiredNutrientSurchargeDiscount.vue?vue&type=style&index=0&id=0face833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0face833",
  null
  
)

export default component.exports